/**
 * A tiny sleepy version of the "World Needs Your Light" bear cub.
 * Used inside the NextBookPopup badge — the whole site whispers the
 * new book with matching art.
 *
 * Renders inside a fixed-size square container. viewBox is 0 0 60 60
 * so it scales cleanly to any pixel size.
 */
export default function SleepyBear({ size = 44 }) {
  return (
    <svg
      viewBox="0 0 60 60"
      width={size}
      height={size}
      role="img"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="sbFur" cx="45%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#E9B87A" />
          <stop offset="55%" stopColor="#BF864A" />
          <stop offset="100%" stopColor="#7E4E23" />
        </radialGradient>
        <radialGradient id="sbBelly" cx="50%" cy="50%" r="60%">
          <stop offset="0%" stopColor="#F7E1B6" />
          <stop offset="100%" stopColor="#D9AC72" />
        </radialGradient>
      </defs>

      {/* Little sleepy z's floating up-right */}
      <text
        x="46"
        y="14"
        fontFamily="'Fredoka', sans-serif"
        fontSize="9"
        fontWeight="700"
        fill="#FFF4C2"
        opacity="0.95"
      >
        z
      </text>
      <text
        x="52"
        y="20"
        fontFamily="'Fredoka', sans-serif"
        fontSize="6"
        fontWeight="700"
        fill="#FFF4C2"
        opacity="0.75"
      >
        z
      </text>

      {/* Ears */}
      <circle cx="14" cy="20" r="6" fill="url(#sbFur)" />
      <circle cx="14" cy="21" r="2.6" fill="#F0B4B0" />
      <circle cx="46" cy="20" r="6" fill="url(#sbFur)" />
      <circle cx="46" cy="21" r="2.6" fill="#F0B4B0" />

      {/* Head */}
      <ellipse cx="30" cy="32" rx="19" ry="17" fill="url(#sbFur)" />

      {/* Muzzle */}
      <ellipse cx="30" cy="38" rx="10" ry="7" fill="url(#sbBelly)" />

      {/* Nose */}
      <ellipse cx="30" cy="34" rx="2.4" ry="1.8" fill="#3D2818" />

      {/* Sleepy closed eyes */}
      <path
        d="M 20 28 Q 23 25 26 28"
        stroke="#3D2818"
        strokeWidth="1.4"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M 34 28 Q 37 25 40 28"
        stroke="#3D2818"
        strokeWidth="1.4"
        fill="none"
        strokeLinecap="round"
      />

      {/* Sleepy smile */}
      <path
        d="M 30 37 Q 28 40 26 39"
        stroke="#3D2818"
        strokeWidth="1.1"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M 30 37 Q 32 40 34 39"
        stroke="#3D2818"
        strokeWidth="1.1"
        fill="none"
        strokeLinecap="round"
      />

      {/* Rosy cheeks */}
      <ellipse cx="18" cy="38" rx="2.6" ry="1.8" fill="#F0B4B0" opacity="0.8" />
      <ellipse cx="42" cy="38" rx="2.6" ry="1.8" fill="#F0B4B0" opacity="0.8" />
    </svg>
  );
}
